import axios from "axios";

import config from "./config";

export default class ImpostoDeRendaService {
  static async auth(cpf,carteira) {
    const bodyFormData = new FormData();
    bodyFormData.append("servico", "autenticaCli");
    bodyFormData.append("cpf",cpf);
    bodyFormData.append("carteira",carteira);
    let response = "";
    try {
      response = await axios.post(config.API_URL_BASE, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      if(response.data.html === "ErroDados"){
        return {html:'<h3 style="text-align:center">Nada encontrado para os dados inseridos</h3>', status:true}
      }
    } catch (err) {
        return {status: false, error:err};
    }
    
    let temp = document.createElement('div');
    temp.innerHTML = response.data.html;

    temp.firstElementChild.style.marginTop = "1rem"

    const form = temp.lastElementChild
    const button = form.lastElementChild
    
    form.style.marginTop = "1rem"
    button.classList.add('btn')
    button.style.marginLeft = "20px"
    button.style.width = "20%"
    button.value = "Imprimir"
    form.children[5].style.height = "auto"
    form.action = "https://portaldocliente.unimedvs.com.br/declaracaoir"

    response.data.html = temp.innerHTML;
    return response.data
  }
}
